export function shouldProvideLoadMore<T>(list: T[], pageSize = 20): boolean {
  const count = list.length
  const hasValues = count > 0
  const isMultipleOfPageSize = count % pageSize === 0
  return hasValues && isMultipleOfPageSize
}

export function nextPageNumber<T>(list: T[], pageSize = 20): number {
  return Math.ceil(list.length / pageSize + 1)
}
